export default __webpack_public_path__ + "static/media/node-icon.517ce67b.svg";